let audioContext: AudioContext | null = null;

function getAudioContext(): AudioContext | null {
  if (typeof window === 'undefined') {
    return null;
  }

  if (!audioContext) {
    const AudioContextClass =
      window.AudioContext ??
      (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AudioContextClass) {
      return null;
    }
    audioContext = new AudioContextClass();
  }

  return audioContext;
}

export function unlockLiveRoomSounds(): void {
  const ctx = getAudioContext();
  if (!ctx) {
    return;
  }

  if (ctx.state === 'suspended') {
    void ctx.resume();
  }
}

function playTone(input: {
  frequency: number;
  startTime: number;
  duration: number;
  volume: number;
  type?: OscillatorType;
}): void {
  const ctx = getAudioContext();
  if (!ctx) {
    return;
  }

  unlockLiveRoomSounds();

  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = input.type ?? 'sine';
  oscillator.frequency.setValueAtTime(input.frequency, input.startTime);
  gain.gain.setValueAtTime(0, input.startTime);
  gain.gain.linearRampToValueAtTime(input.volume, input.startTime + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.001, input.startTime + input.duration);
  oscillator.connect(gain);
  gain.connect(ctx.destination);
  oscillator.start(input.startTime);
  oscillator.stop(input.startTime + input.duration + 0.02);
}

/** Coin chime — own tips and tips from other viewers. */
export function playTipSound(): void {
  const ctx = getAudioContext();
  if (!ctx) {
    return;
  }

  unlockLiveRoomSounds();

  const start = ctx.currentTime;
  playTone({ frequency: 880, startTime: start, duration: 0.11, volume: 0.11 });
  playTone({ frequency: 1174.66, startTime: start + 0.07, duration: 0.14, volume: 0.09 });
  playTone({ frequency: 1567.98, startTime: start + 0.13, duration: 0.18, volume: 0.07, type: 'triangle' });
}

/** Room join — you entered the show or another fan arrived. */
export function playJoinSound(options?: { soft?: boolean }): void {
  const ctx = getAudioContext();
  if (!ctx) {
    return;
  }

  unlockLiveRoomSounds();

  const scale = options?.soft ? 0.55 : 1;
  const start = ctx.currentTime;
  playTone({
    frequency: 392,
    startTime: start,
    duration: 0.2,
    volume: 0.07 * scale,
    type: 'triangle',
  });
  playTone({
    frequency: 523.25,
    startTime: start + 0.09,
    duration: 0.28,
    volume: 0.08 * scale,
  });
  playTone({
    frequency: 659.25,
    startTime: start + 0.18,
    duration: 0.32,
    volume: 0.05 * scale,
    type: 'sine',
  });
}
